import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";

interface TransferenciaRevendaEditar {
  idAutonomoDe: string;
  idAutonomoPara: string;
  idsRevendaUnidade: string[];
  authToken: string;
}

/**
 * Função para transferir uma revenda.
 *
 * @param {TransferenciaRevendaEditar} params - Parâmetros para transferência da revenda.
 * @returns {Promise<any>} - Resposta da API.
 */
export const putTransferirRevenda = async (
  params: TransferenciaRevendaEditar
): Promise<any> => {
  const url = "/api/RevendaUnidade/TransferirRevendaUnidade";
  const { authToken, ...parameters } = params;
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.put(url, parameters, config);
  return response?.data;
};
